import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  verificationData: null,
  success: false,
};

const hederaVerificationSlice = createSlice({
  name: "hederaVerification",
  initialState,
  reducers: {
    fetchVerificationData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.verificationData = null;
    },
    fetchVerificationDataSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.verificationData = action.payload?.data || null;
    },
    fetchVerificationDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || "Failed to fetch verification data";
      state.success = false;
    },
    resetVerificationState: (state) => {
      state.loading = false;
      state.error = null;
      state.verificationData = null;
      state.success = false;
    },
  },
});

export const { actions, reducer } = hederaVerificationSlice;
export const sliceKey = hederaVerificationSlice.name;